import React from 'react';
import { House, Barbell, ForkKnife, ChartLineUp, DotsThree } from '@phosphor-icons/react';

const tabs = [
  { id: 'dashboard', label: 'Home', Icon: House },
  { id: 'workout', label: 'Workout', Icon: Barbell },
  { id: 'nutrition', label: 'Nutrition', Icon: ForkKnife },
  { id: 'progress', label: 'Progress', Icon: ChartLineUp },
  { id: 'more', label: 'More', Icon: DotsThree },
];

export default function BottomNav({ tab, setTab }) {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 flex justify-around items-center glass"
      style={{ height: '68px', paddingBottom: 'env(safe-area-inset-bottom, 0)', borderTop: '1px solid rgba(255,255,255,0.06)', borderRadius: '18px 18px 0 0', backgroundColor: 'rgba(26,26,31,0.9)' }}
      data-testid="bottom-nav"
    >
      {tabs.map(({ id, label, Icon }) => (
        <button
          key={id}
          onClick={() => setTab(id)}
          className={`flex flex-col items-center justify-center gap-0.5 flex-1 h-full relative ${
            tab === id ? 'text-white' : 'text-neutral-500 hover:text-neutral-300'
          }`}
          data-testid={`nav-${id}`}
        >
          <Icon size={22} weight={tab === id ? 'bold' : 'regular'} />
          <span className="text-[9px] font-bold uppercase tracking-wider">{label}</span>
          {tab === id && (
            <div className="absolute bottom-2 w-5 h-[3px] rounded-full" style={{ backgroundColor: 'var(--color-brand)', boxShadow: '0 0 10px var(--theme-glow-strong)' }} />
          )}
        </button>
      ))}
    </nav>
  );
}
